import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast,showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile, verifyAadharWithOtp, generateAadharOtp } from "../../../Services/ApiTestService/aadharTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data } from "../Data";
import { Link ,useLocation } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";

const TestAadhar = () => {
  const [aadharNo, setAadharNo] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [aadharDetails, setAadharDetails] = useState({});
  const [otpSent, setOtpSent] = useState(false); // Track if OTP is sent
  const [clientId, setClientId] = useState('');

  const { serviceName } = useService();



  // Fetch Profile Data on Mount
  useEffect(() => {
    async function fetchProfileData() {
      try {
        setIsLoading(true);
        const response = await fetchProfile(); // API call to get profile details
        setProfileData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching profile data", error);
        showErrorToast("Failed to fetch profile data.");
        setIsLoading(false);
      }
    }
    fetchProfileData();
  }, []);




// Verhoeff algorithm tables (for Aadhaar checksum)
const d = [
  [0,1,2,3,4,5,6,7,8,9],
  [1,2,3,4,0,6,7,8,9,5],
  [2,3,4,0,1,7,8,9,5,6],
  [3,4,0,1,2,8,9,5,6,7],
  [4,0,1,2,3,9,5,6,7,8],
  [5,9,8,7,6,0,4,3,2,1],
  [6,5,9,8,7,1,0,4,3,2],
  [7,6,5,9,8,2,1,0,4,3],
  [8,7,6,5,9,3,2,1,0,4],
  [9,8,7,6,5,4,3,2,1,0]
];

const p = [
  [0,1,2,3,4,5,6,7,8,9],
  [1,5,7,6,2,8,3,0,9,4],
  [5,8,0,3,7,9,6,1,4,2],
  [8,9,1,6,0,4,3,5,2,7],
  [9,4,5,3,1,2,6,8,7,0],
  [4,2,8,6,5,7,3,9,0,1],
  [2,7,9,3,8,0,6,4,1,5],
  [7,0,4,6,9,1,3,2,5,8]
];

const inv = [0,4,3,2,1,5,6,7,8,9];

// ✅ Function to validate Aadhaar Number
 function validateAadhaar(aadhaar) {
  aadhaar = aadhaar.trim();

  // Check if 12 digits and starts with 2-9
  if (!/^[2-9]{1}[0-9]{11}$/.test(aadhaar)) {
    return false;
  }

  let c = 0;
  const reversedArray = aadhaar.split('').reverse().map(x => parseInt(x));
  for (let i = 0; i < reversedArray.length; i++) {
    c = d[c][p[i % 8][reversedArray[i]]];
  }
  return c === 0;
}


 // Validate Aadhar Number and OTP
const validateAadhar = () => {
  const errors = {};

  // Aadhar validation
  if (!validateAadhaar(aadharNo)) {
    errors.aadharNo = "Invalid Aadhaar number. Please enter a valid 12-digit number.";
  //  showErrorToast(errors.aadharNo);
  }

  // OTP validation (only if otpSent is true)
  if (otpSent && (!otp || otp.length !== 6 || isNaN(otp))) {
    errors.otp = "Please enter a valid 6-digit OTP.";
    showErrorToast(errors.otp);
  }

  setErrors(errors);
  return Object.keys(errors).length === 0;
};
  // Submit Aadhar Verification
  const handleSubmit = async () => {
    if (!validateAadhar()) return;

    try {
      setIsLoading(true);
      const response = await verifyAadharWithOtp({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        methodName: "validateotp",
        aadhar: aadharNo,
        otp: otp,
        client_id: clientId,
      });

      setAadharDetails(response?.data?.data || {});
      showSuccessToast("Aadhar Verified Successfully.");
      setAadharNo('');
      setOtpSent(false);
      setIsLoading(false);
    } catch (error) {
      console.error("Error verifying Aadhar:", error);
      showErrorToast("Failed to verify Aadhar.");
      setIsLoading(false);
    }
  };


  const handleAadharSubmit = async () => {
    if (!validateAadhar()) return;
  
    setIsLoading(true);
    try {
      const response = await generateAadharOtp({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        methodName: "getotp",
        aadhar: aadharNo,
      });
  
      const statusCode = response?.status?.code || response?.status;
      const message = response?.message || response?.data?.message || response?.error?.message || "Something went wrong";
  
      if (statusCode === 200) {
        setClientId(response?.data?.data?.client_id);
        setOtpSent(true);
        showSuccessToast(message || "OTP sent successfully, please enter OTP.");
      } else {
        showErrorToast(`${message}`);
      }
  
    } catch (error) {
      showErrorToast("Failed to send OTP. Please try again.");
      console.error("Aadhar OTP error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  


  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-6 gap-3 justify-center md:ml-64 ml-0">


      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>


        <InputWithLabel
          type="text"
          label="Aadhar No"
          placeholder="Enter Aadhar No"
          maxLength={12} // Limit input to 12 digits
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="aadharNo"
          id="aadharNo"
          required={true}
          value={aadharNo}
          onChange={(e) => setAadharNo(e.target.value.replace(/\D/g, ""))} // Prevent non-numeric input
          error={errors.aadharNo}
        />

        {/* Verify button for Aadhar No */}
        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyAadhar"
            name="verifyAadhar"
            text="Verify Aadhar"
            onClick={handleAadharSubmit} // Call generate OTP API
          />
        </div>

        {/* OTP input and submit button will only show after OTP is sent */}
        {otpSent && (
          <>
            <InputWithLabel
              type="text"
              label="OTP"
              placeholder="Enter OTP"
              maxLength={6} // Limit OTP to 6 digits
              className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-24"
              name="otp"
              id="otp"
              required={true}
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} // Prevent non-numeric input
              error={errors.otp}
            />

            <div>
              <Button
                type="button"
                className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
                id="submitOtp"
                name="submitOtp"
                text="Submit OTP"
                onClick={handleSubmit} // Call Aadhar verification with OTP
              />
            </div>
          </>
        )}
      </div>



      <div class="max-w-2xl mx-auto p-2 bg-white rounded-2xl shadow-lg mt-3">
  <h2 class="text-xl font-bold text-center text-gray-800 mb-2">Aadhaar Verification Steps</h2>

  <ol class="list-decimal list-inside text-gray-700 space-y-1">
    <li>Enter your 12-digit Aadhaar number carefully.</li>
    <li>Click on "Send OTP" to receive a One-Time Password (OTP) on your registered mobile number.</li>
    <li>Enter the OTP correctly in the provided field.</li>
    <li>Click on "Verify OTP" to validate and fetch your Aadhaar details.</li>
  </ol>

  <div class="mt-2">
    <h3 class="text-xl font-semibold text-gray-800 mb-2">Important Notes:</h3>
    <ul class="list-disc list-inside text-gray-600 space-y-1">
      <li>Ensure the mobile number linked to your Aadhaar is active.</li>
      <li>Do not refresh the page during the verification process.</li>
      <li>Your Aadhaar number is confidential — handle it securely.</li>
      <li>OTP is valid only for a limited time (usually 5 minutes).</li>
    </ul>
  </div>
</div>

      
   {/* Aadhaar Details Card */}
   {aadharDetails && Object.keys(aadharDetails).length > 0 && (

  <>
  <div className="flex justify-center">
    <h2 className="font-bold text-2xl mt-4">Aadhar Details</h2>
  </div>
  <div className="border border-gray-300 rounded-lg p-4 mt-1 flex justify-center shadow-inner shadow-blue-600">
    {/* Profile Photo */}
    
    <div className="w-[16%] md:w-[12%]">
    <img
  src={
    aadharDetails?.profile_image
      ? `data:image/jpeg;base64,${aadharDetails?.profile_image}`
      : "/path/to/default-placeholder.png"
  }
  alt="Aadhar"
  className="rounded-lg object-cover w-full h-auto"
/>

</div>

    {/* Aadhaar Details */}
    <div className="w-[70%] md:w-[70%] ml-16  grid grid-cols-2 text-lg gap-4 ">
      {/* Render Specific Details */}
      <div className="px-2">
        <span className="font-bold">Name:</span> {aadharDetails?.full_name || "N/A"}
      </div>
      <div className="px-2">
        <span className="font-bold">Aadhaar Number:</span>{" "}
        {aadharDetails?.aadhaar_number || "N/A"}
      </div>
      <div className="px-2">
  <span className="font-bold">Date of Birth:</span>{" "}
  {aadharDetails?.dob
    ? new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(new Date(aadharDetails?.dob))
    : "N/A"}
</div>

<div className="px-2">
  <span className="font-bold">Gender:</span> 
  {aadharDetails?.data?.data?.gender === 'M' ? 'Male' : 
   aadharDetails?.data?.data?.gender === 'F' ? 'Female' : 'N/A'}
</div>

      <div className="px-2">
      <span className="font-bold">Care Of:</span> {aadharDetails?.care_of || "N/A"}
     </div>
     <div className="px-2">
     {aadharDetails?.address ? (
     <>
    <div>
      <span className="font-bold">House:</span>{" "}
      {[
        aadharDetails?.address?.house,
      ]
        .filter(Boolean) 
        .join(", ")}
    </div>
  </>
) : (
  "N/A"
)}
     </div>
    <div className="col-span-2 shadow-inner px-2">
{aadharDetails?.address ? (
  <>
    <div>
      <span className="font-bold">Address:</span>{" "}
      {[
        aadharDetails?.address?.house,
        aadharDetails?.address?.street,
        aadharDetails?.address?.landmark,
        aadharDetails?.address?.loc,
        aadharDetails?.address?.dist,
        aadharDetails?.zip,
      ]
        .filter(Boolean) // Filter out undefined or null values
        .join(", ")}
    </div>
  </>
) : (
  "N/A"
)}
</div>


    </div>
  </div>
  </>
)}
      {/* API Response Card */}
      {aadharDetails && Object.keys(aadharDetails).length > 0 && (
        <div className="border border-gray-300 rounded-lg p-1 mt-2 shadow-inner shadow-blue-800">
          <h2 className="text-2xl font-bold mb-2 text-center">API Response</h2>
          <pre className="bg-slate-100 p-1 rounded-md overflow-auto text-green-600">
            {JSON.stringify(aadharDetails, null, 2)}
          </pre>
        </div>
      )}
    </>
  );
};

export default TestAadhar;  